import { all, call } from "redux-saga/effects";
import authSaga from "./auth/auth.saga";
import setCampaignsSaga from "./campaigns/campaigns.saga";

// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([call(authSaga), call(setCampaignsSaga)]);
}
